/**
 * Reads workflow names from a force-delete conflict response.
 * @param error HTTP error
 * @returns Names that would be paused, or null when the error is something else
 */
export function workflowReferenceNames(error: unknown): string[] | null {
  const body = (error as { error?: { message?: { workflows?: { name: string }[] }; workflows?: { name: string }[] } })
    ?.error;
  const workflows = body?.message?.workflows ?? body?.workflows;
  if (!Array.isArray(workflows) || workflows.length === 0) return null;
  return workflows.map((row) => row.name);
}

/**
 * Asks whether the listed workflows may be paused.
 * @param names Stored workflow names or translation keys
 * @param translate Resolves a name for display. Missing keys stay as the given name.
 * @returns Whether the user confirmed
 */
export function confirmPauseWorkflows(
  names: string[],
  translate: (name: string) => string = (name) => name,
): boolean {
  const labels = names.map((name) => translate(name));
  return window.confirm(
    `Diese Automatisierungen werden pausiert:\n${labels.join('\n')}\n\nTrotzdem löschen?`,
  );
}
